export default __webpack_public_path__ + "static/media/blogpost6.fa52ebdf.png";